import React from 'react';

export const ChevronStepLeft = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.66683 11.9998C9.672 11.8545 9.73667 11.7105 9.86115 11.5995L15.199 6.84018C15.458 6.60856 15.8789 6.60856 16.1387 6.84018C16.3984 7.07113 16.3984 7.44635 16.1387 7.67799L11.2915 11.9998L16.1387 16.3216C16.3984 16.5532 16.3984 16.9285 16.1387 17.1594C15.8789 17.391 15.4581 17.391 15.199 17.1594L9.86115 12.4001C9.73665 12.2891 9.67197 12.1451 9.66683 11.9998Z"
            fill="currentColor"
        />
        <rect x="7" y="6.69983" width="1" height="10.7" rx="0.5" fill="currentColor" />
    </svg>
);
